/*!
 * SingRank - CCP Consulting tracking (Meta Pixel)
 * Built 2026-09-20. Target theme: "SingRank X CCP Consulting V2.1" (COPY, unpublished).
 *
 * SCOPE, and why it is small
 * --------------------------
 * singrank-tracking-standard s0: the full machine (three intent tiers, catalogue feed,
 * Drive sheet, cron container) exists for clients whose real inventory is invisible to the
 * platform pixel - Ablink's 118 vehicles. CCP sells ONE service. There is no catalogue, so
 * there is nothing to dual-fire into (s2) and no id contract to prove (s3). Building those
 * here would produce empty data and a maintenance bill. Do not add them later "for
 * completeness" - add them the day CCP lists items.
 *
 * s1, the rule that costs money when broken: Contact != Lead.
 *   Contact = reached out / moved toward the funnel. A browser.
 *   Lead    = a form carrying a NAME and contact details was submitted. A buyer.
 * These were merged once at Ablink and the Lead count read far above real enquiries;
 * nobody could tell the two apart afterwards. Keep them separate.
 *
 * VERIFY IN A REAL BROWSER, never by reading this file (s8). Paste in the console:
 *   window.__SENT=[];var o=window.fbq;window.fbq=function(){window.__SENT.push([].slice.call(arguments));return o.apply(this,arguments)};
 *   for(var k in o){try{window.fbq[k]=o[k]}catch(e){}}
 * then click a CTA and read window.__SENT.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 1. CONFIG - the only block to edit
   * ------------------------------------------------------------------ */
  /* The id is injected by layout/theme.liquid, the same way GA4's measurement id
     is inline there: one visible place, no app block that vanishes when an app is
     uninstalled. 15-16 digits from Events Manager - NOT the ad-account id
     (act=241596853259219 is an ad account, not a pixel).
     Until it is set this file loads and does nothing. */
  var PIXEL_ID = String(window.SRCCP_PIXEL_ID || '').trim();

  var DEBUG = /[?&]srdebug=1/.test(window.location.search);

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[srccp]'].concat([].slice.call(arguments)));
  }

  if (!/^\d{15,16}$/.test(PIXEL_ID)) {
    log('PIXEL_ID not set - nothing loaded. Put the Events Manager id in CONFIG.');
    return;
  }

  /* ------------------------------------------------------------------ *
   * 2. Pixel bootstrap (Meta's own snippet, unmodified)
   * ------------------------------------------------------------------ */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
  log('init', PIXEL_ID);

  /* ------------------------------------------------------------------ *
   * 3. Dedupe - one event per kind per pageview
   * ------------------------------------------------------------------ */
  var sent = {};
  function fire(kind, name, params) {
    var key = kind + ':' + name + ':' + JSON.stringify(params || {});
    if (sent[key]) { log('dedupe', name); return; }
    sent[key] = 1;
    window.fbq(kind, name, params || {});
    log(kind, name, params || {});
  }

  /* ------------------------------------------------------------------ *
   * 4. Where are we? The funnel has named steps; send them by name so the
   *    ads team can build an audience per step instead of guessing.
   * ------------------------------------------------------------------ */
  var path = window.location.pathname.toLowerCase();
  var step =
      /^\/pages\/eligibility/.test(path) ? 'eligibility' :
      /^\/pages\/pricing/.test(path)     ? 'pricing'     :
      /^\/blogs\//.test(path)            ? 'article'     :
      /^\/pages\/services/.test(path)    ? 'services'    :
      path === '/'                       ? 'home'        : 'other';

  fire('trackCustom', 'FunnelStep', { step: step, path: path });

  /* ------------------------------------------------------------------ *
   * 5. CONTACT - moving toward the money, not yet a lead
   *    Every CTA on this site routes to /pages/eligibility, and pricing
   *    unlocks from there. A click on either is intent, not an enquiry.
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = (a.getAttribute('href') || '').toLowerCase();

    if (href.indexOf('/pages/eligibility') > -1) {
      fire('track', 'Contact', { content_name: 'eligibility_check', from_step: step });
    } else if (href.indexOf('/pages/pricing') > -1) {
      fire('track', 'Contact', { content_name: 'pricing', from_step: step });
    } else if (href.indexOf('mailto:') === 0) {
      fire('track', 'Contact', { content_name: 'email', from_step: step });
    }
    /* Deliberately NOT tracked as Contact: the wa.me/?text= share button.
       It carries no recipient number - it is a reader sharing the article,
       not a visitor contacting CCP. Counting it would inflate Contact with
       people who never tried to reach anyone. */
  }, true);

  /* ------------------------------------------------------------------ *
   * 6. LEAD - a real form carrying a name
   * ------------------------------------------------------------------ */
  /* Lead fires ONCE PER PERSON, not once per pageview. The dedupe in fire() only
     covers a single pageview, so without this a visitor who fills the gate on an
     article and later reaches the wizard counts twice. The Lead total then drifts
     above the number of real people - the same failure as merging Contact and
     Lead, arriving through a different door. */
  var LEAD_KEY = 'srccp_lead_sent';

  function sendLead(label) {
    try {
      if (window.localStorage.getItem(LEAD_KEY) === '1') { log('lead already sent'); return; }
      window.localStorage.setItem(LEAD_KEY, '1');
    } catch (e) { /* private window: fall through and send once for this pageview */ }
    fire('track', 'Lead', {
      content_name: label || 'prequal_gate',
      from_step: step,
      currency: 'SGD'
    });
  }

  /* THERE IS NO submit LISTENER HERE, and that is the whole point.
     
     The first version of this file listened for `submit` on window in the CAPTURE
     phase and fired Lead for any form carrying data-srccp-gate. Browser-tested on
     2026-09-20 and it was WRONG: capture runs before the gate's own handler, so
     Lead fired on a submit the gate then REJECTED. Typing an invalid mobile and
     pressing the button produced a Lead with no lead behind it. Nothing errored,
     nothing looked broken, and the count would have drifted above reality exactly
     the way merging Contact and Lead did at another client.
     
     Reading the code did not show this. Clicking the button did. That is why s8
     of the standard forbids declaring tracking finished by reading code.
     
     Lead now has ONE entry point, called by the gate only after validation passes
     AND the submit has gone through. Nothing else may fire it. */
  window.srccpLead = function (label) { sendLead(label); };

  /* ------------------------------------------------------------------ *
   * 7. PURCHASE is NOT fired here.
   *    Shopify's own checkout fires it. Adding a second Purchase from the
   *    theme double-counts revenue and there is no error to tell you.
   * ------------------------------------------------------------------ */

  log('ready, step =', step);
})();
